<template>

    <div>
         <nav-bar />

        <b-container class="strata-plan-details py-4"
            fluid
            style="background: #F7F7FC;"
        >
            <div class="d-flex justify-content-between d-print-none">
                <h1 class="">Strata Plan Details</h1>

                <div class="print-btns" style="display: flex; align-items: center;column-gap: 5px;">
                        <a @click="handleStrataPlanPdfDownloadClicked">
                            <b-button class="btn btn-primary" style="border-radius: 5px; padding: 5px 15px;" variant="primary">
                                <i class="fas fa-print"></i>
                            </b-button>
                        </a>

                        <b-button
                            class="btn btn-primary" style="border-radius: 5px; padding: 5px 15px;margin-right:8px;"
                            variant="primary"
                                :to="{ name: 'strata-plan-edit', params: { id: $route.params.id, step: 1 } }"
                            >
                            <i class="fas fa-edit" ></i>
                        </b-button>
                </div>
            </div>

            <b-row>
                <b-col xl="8" lg="7" md="12" sm="12" class="mt-3 pl-lg-5 px-md-5">
                    <div
                        class="section-first px-5 py-5"
                    >
                    <img src="http://localhost/strata/public/strata.png" alt="strata connex logo" class="d-none d-print-block str-logo">
                        <h3

                            class="mb-3"
                        >
                            Strata Plan ID: {{strata_plan.type}}-{{ strata_plan.strata_plan_number }}
                        </h3>
                        <ul>
                            <li> <span class="title"> ABN:</span> <span class="sub-title"> {{ strata_plan.abn_acn}} </span></li>
                            <li> <span class="title"> Annual Budget Estimate&nbsp;(ex. GST)</span></li>
                            <li> <span class="title">FY 2021/2022 :</span> <span class="sub-title">&nbsp;${{parseInt(strata_plan.estimated_budget).toLocaleString()}}</span></li>
                        </ul>

                        <hr class="my-4" />

                        <h5 class="font-weight-bold">
                            Strata Manager Details
                        </h5>
                        <ul>
                            <li>
                                <span class="title">Name:</span>  <span class="sub-title"> {{ strata_plan.manager.first_name }}
                            {{ strata_plan.manager.last_name }} </span>
                            </li>
                            <li> <span class="title"> Company:</span> <span class="sub-title"> {{ strata_plan.manager.company_name }} </span></li>
                            <li> <span class="title"> Email:</span> <span class="sub-title"> {{ strata_plan.manager.email }} </span></li>
                            <li> <span class="title"> Phone:</span>  <span class="sub-title">{{ strata_plan.manager.phone }} </span></li>
                            <li> <span class="title"> Alternative Manager: </span> <span v-if="strata_plan.alternate_manager" class="sub-title">  {{strata_plan.alternate_manager.first_name}} {{strata_plan.alternate_manager.last_name}}</span></li>
                        </ul>


                        <hr class="my-4" />

                        <h5 class="font-weight-bold mt-4">
                            Building Manager Details
                        </h5>

                        <ul class="manager-details">
                            <li><span class="title"> Name: </span> <span class="sub-title"> {{ strata_plan.building_manager_name }}</span></li>
                            <li><span class="title"> Email:</span> <span class="sub-title"> {{ strata_plan.building_manager_email }}</span></li>
                            <li><span class="title"> Phone:</span> <span class="sub-title"> {{ strata_plan.building_manager_phone }}</span></li>
                        </ul>
                    </div>
                    <br />

                    <div
                        class=" section-first-in px-5 py-5"
                        style="background-color: #fff; box-shadow: 1px 3px 10px rgba(233, 239, 244, 0.81);"
                    >
                        <h5 class="mb-4" style="color:#333333; font-size: 16px; font-weight: 500;">
                            Photo(s) of Site:
                        </h5>
                        <b-row class="mb-3">
                            <b-col md="3" v-for="(photo,index) in strata_plan.site_photos" :key="index">
                                    <img :src="photo.signed_url" class="img-fluid"  :style="{'height': '170px','width':'100%', 'object-fit': 'cover'} " @click="handleWorkSiteImageClick(photo.signed_url)"/>
                            </b-col>
                            <b-modal id="modal-work-site-image" hide-footer hide-header>
                                <img :src="workSiteModalImageLink" alt="Snow" class="img-fluid">
                            </b-modal>
                        </b-row>
                    </div>
                </b-col>

                <b-col xl="4" lg="5" md="12" sm="12" class="mt-3 pl-lg-3 px-md-5">
                    <div
                        class="section-second p-5"
                    >
                        <div class="deatil-content">
                            <h5

                                class="pb-2 font-weight-bold    "
                            >
                                Address
                            </h5>
                            <ul>
                                <li><span class="title"> Building:</span> <span class="sub-title"> {{ strata_plan.building }}</span></li>
                                <li><span class="title"> Street:</span> <span class="sub-title"> {{ strata_plan.street }}</span></li>
                                <li><span class="title"> Suburb:</span> <span class="sub-title"> {{ strata_plan.suburb }}</span></li>
                                <li><span class="title"> State:</span> <span class="sub-title"> {{ strata_plan.state }}</span></li>
                                <li><span class="title"> Post Code:</span> <span class="sub-title"> {{ strata_plan.postcode }}</span></li>
                                <li><span class="title">Registered Lot(s):</span><span class="sub-title">{{ strata_plan.registered_lots }}</span></li>
                            </ul>

                        </div>
                        <div class="mt-4 mb-4 file-sec">
                            <hr class="my-4" />
                            <h5
                                class="font-weight-bold"
                            >
                                File(s)
                            </h5>
                            <div class="row d-flex mb-4">
                                <div
                                    class="col-md-6"
                                    style="margin-bottom:35px"
                                    v-for="(file,index) in strata_plan.attachments"
                                    :key="'file-'+index"
                                >
                                    <a
                                        style="text-decoration:underline;font-size: 12.5px;"
                                        :href="file.signed_url"
                                        target="_blank"
                                        download
                                        >{{ file.name }}</a
                                    >&nbsp;
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="bottom-content">
                <b-col class="mt-5 px-5">
                    <footer-component></footer-component>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import phoneNoMixin from "../../../../../mixins/phoneNoMixin";
import FooterComponent from "../../../includes/FooterComponent.vue";


export default {
    components: {
        NavBar,
        FooterComponent,
    },
    mixins: [phoneNoMixin],
    data() {
        return {
            strata_plan: {
                manager: {}
            },
            workSiteModalImageLink: '',
        };
    },
    mounted() {
       this.fetchQuote(this.$route.params.id);
    },
    methods: {
        fetchQuote(id) {
            axios
                .post("api/manager/strata-plan/getDetails", {
                    id: id,
                    load_strata_plan: 1,
                    load_invitations: 1,
                    load_categories: 1,
                    load_insurances_media: 1
                })
                .then(response => {
                    this.strata_plan = response.data.strataplan;
                    this.strata_plan.manager.phone = this.strata_plan.manager.user_phone ? this.formatPhoneForAustraliaBySpace(this.strata_plan.manager.user_phone) : "";
                    this.strata_plan.building_manager_phone = this.strata_plan.strata_manager_phone ? this.formatPhoneForAustraliaBySpace(this.strata_plan.strata_manager_phone) : "";
                });
        },
        handleWorkSiteImageClick(image_link){
            this.workSiteModalImageLink= image_link
            this.$bvModal.show('modal-work-site-image')
        },
      handleStrataPlanPdfDownloadClicked() {
        axios({
            url: 'api/manager/strata-plan/generate-pdf',
            method: 'post',
            responseType: 'blob',
            data: {
                format: 'pdf',
                strata_plan_id: this.$route.params.id,
            }
        }).then((response) => {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var blobURL = URL.createObjectURL(blob);
            window.open(blobURL);
        });
    },
    }
};
</script>

<style scoped>
    .section-first ul li span.title
     {
        font-weight: 600;
    }

    .strata-plan-details ul li span.sub-title,
    ul.manager-details li span.sub-title {
        margin-left: 10px;
    }
/************
=============
PRINT CSS
=============
*************/
@media print {
    body {
        font-family: Georgia, 'Times New Roman', Times, serif;
        line-height: 24pt;
        /* font-size: 16pt; */
        background: none;
    }

    .section-first-in,
    .bottom-content,
    .file-sec,
    hr {
        display: none;
    }

    .section-first h3,
    .section-first h5,
    .deatil-content h5 {
        text-align: center;
        color: #4682b4;
    }

    .section-first ul,
    .deatil-content ul {
        border: 1px solid black;
    }

    .section-first ul:not(:last-child) {
        margin-bottom: 40pt;
    }

    .section-first ul li,
    .deatil-content ul li {
        padding: 10px;
    }

    .section-first ul li:not(:last-child),
    .deatil-content ul li:not(:last-child) {
        border-bottom: 1px solid black;
    }

    .str-logo {
        margin-bottom: 40pt;
    }

    .deatil-content {
        position: relative;
        top: -60pt;
    }
}

</style>
